export default __webpack_public_path__ + "static/media/1.c44e3987.jpg";